import type { LHCDetailInvoiceRowData } from '../types';

export type MutationHistoryFilterLabel =
  | 'Semua'
  | 'Pending'
  | 'Mutasi'
  | 'Faktur';

type MutationHistoryTypeParam = 'billing' | 'bank-mutation';

const DD_MM_YYYY_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const YYYY_MM_DD_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const FALLBACK_BILTO = '-';
const FILTER_TO_TYPE_MAP: Readonly<
  Partial<Record<MutationHistoryFilterLabel, MutationHistoryTypeParam>>
> = {
  Faktur: 'billing',
  Mutasi: 'bank-mutation',
};

export const mapMutationHistoryFilterToType = (
  filter: MutationHistoryFilterLabel
): MutationHistoryTypeParam | undefined => FILTER_TO_TYPE_MAP[filter];

export const toApiDateFromUiValue = (value: string): string | undefined => {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return undefined;
  }

  if (YYYY_MM_DD_REGEX.test(trimmedValue)) {
    return trimmedValue;
  }

  const matched = DD_MM_YYYY_REGEX.exec(trimmedValue);
  if (!matched) {
    return undefined;
  }

  const [, day, month, year] = matched;
  return `${year}-${month}-${day}`;
};

export const getSapNoBiltoFromRow = (
  row: LHCDetailInvoiceRowData | null
): string | null => {
  if (!row) {
    return null;
  }

  const billTo = row.billTo.trim();
  if (!billTo || billTo === FALLBACK_BILTO) {
    return null;
  }

  return billTo;
};
